import { Component, Output, EventEmitter, Input, SimpleChanges, OnChanges, OnInit, ViewChild } from '@angular/core';
import { IncentiveService } from '../create-incentive/create-incentive.service';
import {Router, ActivatedRoute} from '@angular/router';
import { LoaderService } from '../loader.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { SharedService } from '../shared/shared.service';
import Utils  from '.././utils/utils';
import { defaultStatusMessage, userSelectorStatusMessages } from ".././utils/utils";
import {
  INCENTIVE_APPROVAL_PREVIEW_KEY_PREFIX,
  IncentiveApprovalPreviewContext,
  IncentiveApprovalRequestsService,
} from '../incentive-approval-requests/incentive-approval-requests.service';
import { AuthService } from '../auth.service';
import { AUTHZ_FEATURES } from '../constants/permissions';
import { permissionsForFeature } from '../utils/permission.utils';
import { AlertDialogOptions, AlertDialogService } from '../shared/alert-dialog/alert-dialog.service';
import { isLogisticsV2Version } from '../create-incentive/quality-conditions.model';
import { AuthzAccessHintService } from '../shared/authz-access-hint/authz-access-hint.service';

const ADHOC_TYPE = 'Adhoc';
const OTHERS = 'Others';

@Component({
  selector: 'app-view-incentive',
  templateUrl: './view-incentive.component.html',
  styleUrls: ['../create-incentive/preview/preview.component.css'],
  providers: [DatePipe]
})

export class ViewIncentiveComponent implements OnInit {
  public header: any = 'View Incentive';
  public incentiveData: any = {};
  public userSelectorCount = {};
  public isHHIncentive: boolean;
  public isMCIncentive = false;
  public authzAccessHintMessage: string = '';
  public authzAccessHintUrl: string = '';
  public microCorridorDisplay = '';
  public selectorStatusUpdateTimer: number;
  public isCreateOrDuplicateFlow = true;
  public variables: any;
  public goal = [];
  public state = this.sharedService.STATE.VIEW;
  public order: boolean;
  public distance: boolean;
  public dailyData: any;
  public type = "view"
  public condition: any = '&&';
  public userSelectorStatus = {
    status: "UNKNOWN",
    ...defaultStatusMessage
  };

  public weeklyIncentiveData = [
    {
      'days': 'All',
      'startDay': { day: 'Monday', index: 1 },
      'endDay': { day: '', index: null }
    }
  ];
  public dailyIncentiveData = [
    {
      'days': 'All',
    }
  ];
  public startDay: any;
  public endDay: any;
  public subSetCount = [];
  public orderChecked = false;
  public distanceChecked = false;
  public cancellationChecked = false;
  public cancellationLimitScope = "";
  public cancellationGlobalLimit = 0;
  public setsCancellationLimit = [0];
  public maxOrderDistanceChecked = false;
  public maxOrderDistanceGlobal = 0;
  public qualityChecked = false;
  public active = true;
  public qualitativeMetrics = ['APR', 'DPR'];
  public dailyIncentiveTimeBuckets = environment.incentiveTimeBuckets;
  public overlappingTimeBuckets = {};
  private userSelectorId: string;
  formLoaded = false;
  public isApprovalPreview = false;
  public approvalRequestId: string;
  public approvalRequestStatus = '';
  public approvalRequestStatusDisplay = '';
  public canShowApproveAction = false;
  public canShowRejectAction = false;
  public showInsufficientPermissionsMessage = false;
  public showRequestNotPendingMessage = false;
  public processingApprovalRequest = false;
  private approvalPreviewContext: IncentiveApprovalPreviewContext;
  private currentUserEmail = '';
  public changedFields: Array<{field: string, oldValue: any, newValue: any}> = [];
  public authzAccessHint: { message: string; requestUrl: string } | null = null;
  @Output() back: EventEmitter<any> = new EventEmitter();

  constructor(
    private incentiveService: IncentiveService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private router: Router,
    private datePipe: DatePipe,
    private sharedService: SharedService,
    private approvalRequestsService: IncentiveApprovalRequestsService,
    private authService: AuthService,
    private alertDialogService: AlertDialogService,
    private authzAccessHintService: AuthzAccessHintService,
  ) {}

  ngOnInit() {
    this.loaderService.openLoading();
    const incentiveId = this.route.snapshot.paramMap.get('incentiveId');
    this.isApprovalPreview = this.route.snapshot.queryParamMap.get('preview') === 'approval';
    if (this.isApprovalPreview) {
      this.approvalRequestId = incentiveId;
      this.loadApprovalPreviewFromConfigManager(incentiveId);
      return;
    }
    this.incentiveService.getIncentive(incentiveId)
    .subscribe((res: any) => {
      this.applyIncentiveData(res);
    }, err => console.log(err))
    this.loadAccessHint();
  }

  private async loadAccessHint() {
    this.authzAccessHint = await this.authzAccessHintService.getAccessHintData("incentive");
  }

  private loadApprovalPreviewFromConfigManager(requestId: string) {
    this.approvalRequestsService.fetchApprovalRequestById(requestId)
      .subscribe(async (row: any) => {
        if (!row || row.newValue == null) {
          this.loaderService.closeLoading();
          console.error('Approval request not found in config-manager for', requestId);
          return;
        }
        await this.applyApprovalRequestRow(requestId, row);
      }, async () => {
        const previewData = this.readApprovalPreview(requestId);
        if (!previewData) {
          this.loaderService.closeLoading();
          console.error('Approval preview data not found for request', requestId);
          return;
        }
        const context = this.approvalPreviewContext || { requestId, newValue: previewData };
        await this.applyApprovalRequestRow(requestId, {
          ...context,
          newValue: previewData,
        });
      });
  }

  private async applyApprovalRequestRow(requestId: string, row: any) {
    const requestStatus = row ? String(row.requestStatus || row.status || '').trim() : '';
    this.approvalPreviewContext = {
      requestId,
      requestStatus,
      operation: row.operation,
      createdBy: row.createdBy,
      resourceId: row.resourceId,
      resource: row.resource,
      key: row.key,
      version: row.version,
      newValue: row.newValue,
      oldValue: row.oldValue || null,
    };
    this.approvalRequestStatus = requestStatus;
    const normalized = requestStatus.trim().toLowerCase();
    this.approvalRequestStatusDisplay = requestStatus ? normalized.charAt(0).toUpperCase() + normalized.slice(1) : 'Unknown';
    if (row.operation && row.operation.toLowerCase() === 'update' && row.oldValue) {
      this.computeChangedFields(row.oldValue, row.newValue);
    }
    this.initApprovalPermissions();
    this.applyIncentiveData(row.newValue);
  }

  private readApprovalPreview(requestId: string) {
    const raw = sessionStorage.getItem(`${INCENTIVE_APPROVAL_PREVIEW_KEY_PREFIX}${requestId}`);
    if (!raw) {
      return null;
    }
    try {
      const parsed = JSON.parse(raw);
      if (parsed && parsed.newValue != null) {
        this.approvalPreviewContext = parsed as IncentiveApprovalPreviewContext;
        return parsed.newValue;
      }
      this.approvalPreviewContext = { requestId, newValue: parsed };
      return parsed;
    } catch (error) {
      return null;
    }
  }

  private initApprovalPermissions() {
    this.authService.getUserDetails().subscribe((user: any) => {
      const incentivePermissions = permissionsForFeature(AUTHZ_FEATURES.INCENTIVE, this.authService.getAuthzPanels());
      const canApprove = this.authService.isAuthorizedFor(incentivePermissions.approve, AUTHZ_FEATURES.INCENTIVE);
      const canEdit = this.authService.isAuthorizedFor(incentivePermissions.edit, AUTHZ_FEATURES.INCENTIVE);

      this.currentUserEmail = (user && user.email) || '';
      const status = (this.approvalRequestStatus || '').toLowerCase();
      const isPending = !status || status === 'pending';
      const isCreator = this.isSamePersonAsRequestCreator();

      this.canShowApproveAction = canApprove && isPending && !isCreator;
      this.canShowRejectAction = isPending && (canApprove || (isCreator && canEdit));

      const hasAnyAction = this.canShowApproveAction || this.canShowRejectAction;
      if (!hasAnyAction && this.approvalRequestStatus) {
        this.showInsufficientPermissionsMessage = isPending;
        this.showRequestNotPendingMessage = !isPending;
      }
    });
  }


  private isSamePersonAsRequestCreator(): boolean {
    const creator = this.approvalPreviewContext && this.approvalPreviewContext.createdBy;
    if (!creator || !this.currentUserEmail) {
      return false;
    }
    return (creator || '').trim().toLowerCase() === (this.currentUserEmail || '').trim().toLowerCase();
  }

  async approveIncentiveRequest() {
    if (this.isSamePersonAsRequestCreator()) {
      this.alertDialogService.open({
        title: 'Cannot approve',
        message: 'This request cannot be approved by the same person who submitted it. Please ask another approver to review this request.',
      });
      return;
    }
    await this.submitApprovalRequest('approve');
  }

  async rejectIncentiveRequest() {
    await this.submitApprovalRequest('reject');
  }

  private async submitApprovalRequest(action: 'approve' | 'reject') {
    if (!this.approvalRequestId || this.processingApprovalRequest) {
      return;
    }
    this.processingApprovalRequest = true;
    this.loaderService.openLoading();
    try {
      if (!this.approvalPreviewContext) {
        throw { error: { message: 'Approval request data is missing. Re-open the request from the list.' } };
      }
      const resource = this.approvalPreviewContext.resource || 'incentives';
      const body = { resource, comment: action === 'approve' ? 'Approved' : 'Rejected' };
      const request$ = action === 'approve'
        ? this.approvalRequestsService.approveRequest(this.approvalRequestId, body)
        : this.approvalRequestsService.rejectRequest(this.approvalRequestId, body);
      await request$.toPromise();
      this.alertDialogService.open({
        title: 'Success',
        message: action === 'approve'
          ? 'Incentive approval request was approved successfully.'
          : 'Incentive approval request was rejected successfully.',
      });
      this.canShowApproveAction = false;
      this.canShowRejectAction = false;
      this.approvalRequestStatus = action === 'approve' ? 'approved' : 'rejected';
      this.approvalRequestStatusDisplay = action === 'approve' ? 'Approved' : 'Rejected';
    } catch (error) {
      const message = (error && error.error && error.error.message)
        || (error && error.error && error.error.data && error.error.data.error)
        || (action === 'approve'
          ? 'Failed to approve incentive request.'
          : 'Failed to reject incentive request.');
      this.alertDialogService.open({
        title: 'Failed',
        message,
      });
    } finally {
      this.processingApprovalRequest = false;
      this.loaderService.closeLoading();
    }
  }

  private applyIncentiveData(res: any) {
    this.incentiveData = res;
    this.isHHIncentive = this.incentiveData.tags ? this.incentiveData.tags.includes("HH") : false;
    const ap = this.incentiveData.assignmentPolicy;
    this.isMCIncentive = !!(ap && ap.type === 'micro_corridor' && ap.ids && ap.ids[0]);
    this.microCorridorDisplay = this.isMCIncentive
      ? (ap.name && String(ap.name).trim()) || String(ap.ids[0])
      : '';
    this.active = this.incentiveData.active;
    this.findTypeOfIncentive(this.incentiveData);
    this.passGoalsInfo();
    this.formLoaded = true;
    this.loaderService.closeLoading();
    if (!this.isHHIncentive && !this.isMCIncentive && this.incentiveData.ruleId) {
      this.sharedService.getUserSelectorDetails(this.incentiveData.ruleId)
        .subscribe((response: any) => {
          this.userSelectorCount = { count: response.userCount };
        }, err => console.log(err));
    }
  }

  goBack() {
    if (this.route.snapshot.queryParamMap.get('preview') === 'approval') {
      this.router.navigate(['/incentive-approval-requests']);
      return;
    }
    this.router.navigate(['/incentives']);
  }

  isLogisticsV2View(): boolean {
    return isLogisticsV2Version(this.incentiveData && this.incentiveData.incentiveVersion);
  }

  deferredPayoutPolicyViewLabel(): string {
    const policy = this.incentiveData && this.incentiveData.payoutPolicy;
    if (!policy) {
      return '';
    }
    return policy.mode || 'MaxDayVsSlots';
  }

  private computeChangedFields(oldValue: any, newValue: any) {
    this.changedFields = [];
    if (!oldValue || !newValue) return;

    const fieldLabels: {[key: string]: string} = {
      incentiveName: 'Name',
      incentiveDisplayName: 'App Display Name',
      incentiveType: 'Type',
      cities: 'Cities',
      serviceNames: 'Services',
      startDate: 'Start Date',
      endDate: 'End Date',
      priority: 'Priority',
      active: 'Active',
      ruleName: 'User Selector',
      smsTemplate: 'SMS Template',
      tnc: 'Terms & Conditions',
      messageLocale: 'Message Locale',
    };

    Object.keys(fieldLabels).forEach(key => {
      const oldVal = oldValue[key];
      const newVal = newValue[key];
      if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
        this.changedFields.push({
          field: fieldLabels[key],
          oldValue: this.formatValue(oldVal),
          newValue: this.formatValue(newVal)
        });
      }
    });

    // Check goals separately for detailed diff
    if (JSON.stringify(oldValue.goals) !== JSON.stringify(newValue.goals)) {
      this.changedFields.push({
        field: 'Goals',
        oldValue: this.parseGoalsForDisplay(oldValue.goals),
        newValue: this.parseGoalsForDisplay(newValue.goals)
      });
    }
  }

  private formatValue(val: any): string {
    if (val == null) return '-';
    if (Array.isArray(val)) return val.join(', ');
    if (typeof val === 'object') return JSON.stringify(val);
    return String(val);
  }

  private parseGoalsForDisplay(goals: any): any {
    if (!goals) {
      return null;
    }

    const sets: any[] = [];

    Object.keys(goals).forEach(day => {
      goals[day].forEach((goal: any, idx: number) => {
        const timeSlots = goal.timeSlot && goal.timeSlot.length
          ? goal.timeSlot.map((ts: any) => ts.fromTime + '-' + ts.toTime).join(', ')
          : '-';

        const rules = goal.rules
          ? goal.rules.map((r: any) => ({
              orders: r.order,
              amount: r.amount
            }))
          : [];

        sets.push({
          setNumber: idx + 1,
          timeSlot: timeSlots,
          rules: rules
        });
      });
    });

    return sets;
  }

  findTypeOfIncentive(defaultValue) {
    if (defaultValue && (defaultValue.incentiveType === 'Daily'
    || defaultValue.incentiveType === 'Adhoc')) {
      this.getDailyIncentiveData(this.incentiveData);
    } else {
      this.getWeeklyIncentiveData(this.incentiveData);
    }
  }

  private getWeeklyIncentiveData(defaultValue) {
    this.condition = defaultValue.selectedCondition;
    const incentives = [];
    let formattedWeeklyincentiveData;
    Object.keys(defaultValue.goals).forEach((goalInDays, index) => {
      formattedWeeklyincentiveData = {};
      formattedWeeklyincentiveData['days'] = goalInDays;
      const weekDays = goalInDays.split(',');
      formattedWeeklyincentiveData['startDay'] = { day: weekDays[0].trim(), index: Utils.findIndexOfDay(weekDays[0]) };
      formattedWeeklyincentiveData['endDay'] = {
        day: weekDays[weekDays.length - 1].trim(),
        index: Utils.findIndexOfDay(weekDays[weekDays.length - 1])
      };
      const weekWiseIncentive = defaultValue.goals[goalInDays];
      weekWiseIncentive.map(incentive => {
        incentive.timeSlot = incentive.timeSlot.map(slot => {
          return {
            fromTime: Utils.timeToTimeStamp(slot.fromTime),
            toTime: Utils.timeToTimeStamp(slot.toTime),
          };
        });
      });
      const incentiveStartDate = new Date(defaultValue.startDate).getTime();
      const currentDate = new Date().getTime();
      var t = Math.round(currentDate - incentiveStartDate) / (1000 * 60 * 60 * 24);
      if ((t) >= 7) {
        formattedWeeklyincentiveData['disabled'] = true;
      }
      else if (t <= 6 && t >= 0) {
        if (formattedWeeklyincentiveData['startDay'].index <= new Date().getUTCDay()) {
          formattedWeeklyincentiveData['disabled'] = true;
        }
      }
      weekWiseIncentive.forEach((incentive, index) => {
        const weeklyIndex = incentives.length;
        formattedWeeklyincentiveData[weeklyIndex] = incentive;
        incentives.push(formattedWeeklyincentiveData);
      });
    });
    this.weeklyIncentiveData = incentives
  }

  private getDailyIncentiveData(defaultValue) {
    const incentives = [];
    this.condition = defaultValue.selectedCondition;;
    const formattedDailyincentiveData = {
      'days': 'All',
    };
    Object.keys(defaultValue.goals).forEach((goalInDays, index) => {
      const dayWiseIncentive = defaultValue.goals[goalInDays];
      dayWiseIncentive.map(incentive => {
        incentive.timeSlot = incentive.timeSlot.map(slot => {
          return {
            fromTime: Utils.timeToTimeStamp(slot.fromTime),
            toTime: Utils.timeToTimeStamp(slot.toTime),
          };
        });
      });
      dayWiseIncentive.forEach((incentive, index) => {
        formattedDailyincentiveData[index + 1] = incentive;
      });
    });

    defaultValue.selectedVariable.forEach((variable) => {
      switch (variable) {
        case 'order': {
          this.orderChecked = true;
          break;
        }
        case 'distance': {
          this.distanceChecked = true;
          break;
        }
        case 'quality': {
          this.qualityChecked = true;
          break;
        }
        case 'cancellation': {
          this.cancellationChecked = true;
        }
        case 'maxOrderDistance': {
          this.maxOrderDistanceChecked = true;
        }
      }
      var goalsKey = Object.keys(defaultValue.goals)[0];
      this.setsCancellationLimit = [];
      this.cancellationGlobalLimit = defaultValue.cancellationLimit;
      this.maxOrderDistanceGlobal = defaultValue.maxOrderDistance;
      for (var set of defaultValue.goals[goalsKey]) {
        this.setsCancellationLimit.push(set.cancellationLimit);
      }
      if (this.cancellationChecked) {
        if (defaultValue.cancellationLimit != 0) {
          this.cancellationLimitScope = "global";
        } else {
          this.cancellationLimitScope = "set";
        }
      }
    });
    this.dailyIncentiveData = [formattedDailyincentiveData];

  }


  async passGoalsInfo() {
    let goalsInfo = {};
    if (this.incentiveData.incentiveType === 'Daily'
    || this.incentiveData.incentiveType === 'Adhoc') {

      if (this.incentiveData.incentiveType === 'Daily') {
        goalsInfo['cancellationLimitScope'] = this.cancellationLimitScope;
        goalsInfo['cancellationLimit'] = this.cancellationGlobalLimit;
        goalsInfo['cancellationChecked'] = this.cancellationChecked;
        goalsInfo['setsCancellationLimit'] = this.setsCancellationLimit;
      }
      if (this.incentiveData.incentiveType === 'Adhoc') {
        goalsInfo['maxOrderDistanceGlobal'] = this.maxOrderDistanceGlobal;
        goalsInfo['maxOrderDistanceChecked'] = this.maxOrderDistanceChecked;
      }
      goalsInfo['dailyIncentiveData'] = this.dailyIncentiveData;

    } else if (this.incentiveData.incentiveType === 'Weekly Fixed') {
        goalsInfo['weeklyIncentiveData'] = this.weeklyIncentiveData;

    } else {
        goalsInfo['weeklyIncentiveData'] = this.weeklyIncentiveData;
    }
    goalsInfo['selectedVariable'] = this.incentiveData.selectedVariable;
    goalsInfo['selectedCondition'] = this.incentiveData.selectedCondition;

    this.incentiveData['goalsInfo'] = goalsInfo;

    if (this.incentiveData) {
      this.header = 'View - ' + this.incentiveData.incentiveType + ' incentive - ' +
        this.datePipe.transform(this.incentiveData.startDate, 'd MMMM yy')
        + ' to ' + this.datePipe.transform(this.incentiveData.endDate, 'd MMMM yy');

      const details = await Utils.fetchUserSelectorStatus(
        this.type,this.userSelectorId,this.incentiveData,
        this.userSelectorStatus, this.sharedService
      );
      if (details !== undefined) {
        this.userSelectorStatus = details.userSelectorStatus;
        this.userSelectorId = details.userSelectorId;
      }
    }

    if (this.incentiveData.goalsInfo && this.incentiveData.goalsInfo.dailyIncentiveData) {
      this.dailyData = _.cloneDeep(this.incentiveData.goalsInfo.dailyIncentiveData);
    }
    if(this.incentiveData.goalsInfo && this.incentiveData.goalsInfo.weeklyIncentiveData) {
      this.dailyData = _.cloneDeep(this.incentiveData.goalsInfo.weeklyIncentiveData);
    }

    this.goal = Utils.organizeData(this.type, this.incentiveData,this.dailyData, this.datePipe,
    this.variables);
  }

}
